import {createReducer, on} from '@ngrx/store';
import {clearClipByIDState, loadClipByID, loadClipByIDFailure, loadClipByIDSuccess} from './clips.load-by-id.actions';
import {Clip} from '../../../services/api/clips/clip.model';

export interface State {
  record: Clip | null;
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false
};


export const loadClipByIdReducer = createReducer(
  initialState,

  on(loadClipByID, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: true
  })),
  on(loadClipByIDSuccess, (state: State, action): State => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false
  })),
  on(loadClipByIDFailure, (state: State, action): State => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(clearClipByIDState, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: false
  }))
);
